import React from 'react'
import { useTranslation } from 'react-i18next'
import { DateSuggest } from '@fs/zion-standards'
import { initDatePicker, useDmcDatePickerController } from './DmcDatePickerController'
import { isNotNullOrUndefinedOrEmpty, isNullOrUndefinedOrEmpty } from '../../../util/Utils'

export default () => {}

export function DmcDatePicker({
  label,
  disabled,
  initialTextboxFormattedDate,
  selectedItem,
  setSelectedItem,
  validMessage,
  errorMessage,
  warningValidate,
  dayMonthYearDateFormat,
  monthYearDateFormat,
  yearDateFormat,
  onBlur,
  idType,
}) {
  const { t } = useTranslation()
  if (isNullOrUndefinedOrEmpty(selectedItem) && isNotNullOrUndefinedOrEmpty(initialTextboxFormattedDate)) {
    setSelectedItem(
      initDatePicker(initialTextboxFormattedDate, dayMonthYearDateFormat, monthYearDateFormat, yearDateFormat)
    )
  }

  const { datePickerActions } = useDmcDatePickerController(
    selectedItem,
    setSelectedItem,
    dayMonthYearDateFormat,
    monthYearDateFormat,
    yearDateFormat
  )
  if (selectedItem && !selectedItem.key) {
    selectedItem.key = ''
  }

  return (
    <DateSuggest
      id={idType ? `${idType}Date` : 'Date'}
      validMessage={validMessage}
      errorMessage={errorMessage}
      warningValidate={warningValidate}
      label={label || t('date', 'Date')}
      disabled={disabled}
      initialSelectedItem={selectedItem}
      selectedItem={selectedItem}
      onSuggestionSelected={datePickerActions.setNewSelectedItem}
      onBlur={onBlur}
      onClear={() => {
        datePickerActions.setNewSelectedItem()
      }}
    />
  )
}
